export default {"src":"/_next/static/media/NU.e10ff96c.svg","height":18,"width":18};